
    import {
        defineComponent,
    } from 'vue';

    export default defineComponent({
        props: {
            isBoxShadow: {
                type: Boolean,
                default: false,
            },
        },
    });
